/**
 * @module ProductTypesList
 */

import Component from '../base/Component';
import './styles.css';

import '../../images/sprite/skin_type_1.svg';
import '../../images/sprite/skin_type_2.svg';
import '../../images/sprite/skin_type_3.svg';
import '../../images/sprite/skin_type_4.svg';
import '../../images/sprite/skin_type_5.svg';
import '../../images/sprite/skin_type_6.svg';
import '../../images/sprite/hair_type_1.svg';
import '../../images/sprite/hair_type_2.svg';
import '../../images/sprite/hair_type_3.svg';
import '../../images/sprite/hair_type_4.svg';
import '../../images/sprite/hair_type_5.svg';
import '../../images/sprite/hair_type_6.svg';
import '../../images/sprite/hair_type_7.svg';
import '../../images/sprite/hair_type_8.svg';

/**
 * Раздел UI Kit.
 */
export default class ProductTypesList extends Component {
    static className = 'product-types-list';
}
